import React from "react"
import{
  Box,
  Chip,
  Popover,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  ListSubheader,
  Typography
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"

class ChipRedimidor extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={anchorEl:null}
    this.onPopoverClose=this.onPopoverClose.bind(this)
    this.onPopoverToggle=this.onPopoverToggle.bind(this)
    this.renderRolDetails=this.renderRolDetails.bind(this)
    this.renderPlacesXRol=this.renderPlacesXRol.bind(this)
  }

  onPopoverClose(){
    console.log("CLOSE")
    this.setState({anchorEl:null})
  }

  onPopoverToggle(evt){
    if(this.state.anchorEl){
      this.setState({anchorEl:null})
    }else{
      this.setState({anchorEl:evt.currentTarget})
    }
  }

  renderRolDetails(){
    const {theme, rolRedimidor} = this.props
    if(rolRedimidor){
      const permissions = rolRedimidor.rolPermissions
      return permissions.map((p, index)=>{
        return (
          <ListItem color="primary" style={index%2==0?theme.table.row:theme.table.rowColor}>
            <ListItemText primary={p.label}/>
          </ListItem>
        ) 
      })
    }
  }

  renderPlacesXRol(){
    const {theme, rolRedimidor} = this.props
    if(rolRedimidor){
      const places = rolRedimidor.rolPlaces
      return places.map((p, index)=>{
          return (
            <ListItem color="primary" style={index%2==0?theme.table.row:theme.table.rowColor}>
              <ListItemText primary={p.plcName} secondary={p.plcAddress}/>
            </ListItem>
          )
        })
    } 
  }
  render(){
    const {key, theme, rolRedimidor, onDelete} = this.props
    console.log("RENDER CHIP REDIMIDOR", rolRedimidor)
    return (
    <div key={key}>
        <Chip 
          color="primary" 
          label={rolRedimidor.rolName}
          onDelete={onDelete}
          clickeable
          onClick={this.onPopoverToggle}
          // onMouseEnter={this.onPopoverOpen}
          // onMouseLeave={this.onPopoverClose}
        />
        <Popover
          style={{padding:10, backgroundColor:"f3f3f3"}}
          open={Boolean(this.state.anchorEl)}
          // anchorEl={this.state.anchorEl}
          anchorPosition={{ top: 20, left: 20 }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          onClose={this.onPopoverClose}>
            <Box style={{backgroundColor:"#000", padding:10, justifyContent:"center", alignItems:"center"}}>
              <Typography variant="subtitle1">{rolRedimidor.rolName}</Typography>
            </Box>
            {/* <Box style={{display:"flex"}}> */}
            <List disablePadding dense
                  
                      subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                          Tipos de tickets dónde aplican los permisos
                        </ListSubheader>
                  }>
                    {this.renderRolDetails()}
            </List>
            <List disablePadding dense
                subheader={
                  <ListSubheader component="div" id="nested-list-subheader">
                    Ubicaciones dónde aplican los permisos
                  </ListSubheader>
            }>
              {this.renderPlacesXRol()}
          </List>
          {/* </Box> */}
        </Popover>
      </div>
    )
  }
}

export default withTheme(ChipRedimidor)


// WEBPACK FOOTER //
// ./src/components/ChipRedimidor/ChipRedimidor.js